'use client'

import { ComponentPropsWithoutRef } from "react"
import { usePathname } from "next/navigation"

type MenuEntryProps = ComponentPropsWithoutRef<'li'> & {
    aroevenSlug: string,
    entryPathname?: string
}

/**
 * Top level menu entry, highlighted when the current page is under its pathname
 */
export default function MenuEntry({
    aroevenSlug,
    entryPathname,
    className = '',
    ...props
}: MenuEntryProps) {

    const pathname = getVisiblePathname(usePathname(), aroevenSlug)

    return <li className={className + (pathname.indexOf(entryPathname) === 0 ? ' hoveractive' : '')} {...props} />
}

/**
 * The middleware rewrites /page into /<slug>/page : the server render may see the rewritten pathname
 * while the browser sees the visible one, both are compared without the slug to render the same class
 */
function getVisiblePathname(pathname: string, slug: string): string {
    const prefix = '/' + slug
    if (pathname === prefix) {
        return '/'
    }
    if (pathname.startsWith(prefix + '/')) {
        return pathname.slice(prefix.length)
    }
    return pathname
}
